import Vue from 'vue';

import VueRouter from 'vue-router';

import '~/assets/main.less';

import routes from '~/src/router';

Vue.use(VueRouter);

const branchname = process.env.BRANCH_PREFIX || '';
const router = new VueRouter({
  routes,
  base: `${branchname}/`,
  mode: 'history'
});
new Vue({
  el: '#app',
  router,
  render: h => h({ template: '<div id="app"><router-view></router-view></div>' }),
  mounted() {
    // You'll need this for renderAfterDocumentEvent.
    document.dispatchEvent(new Event('render-event'));
  }
});
